import { useEffect, useRef, useState } from 'react';
import { TRUSTPILOT_CONFIG } from '@/config/trustpilot';

export const TrustpilotWidget = () => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadScript = () => {
      // Check if script already exists
      const existingScript = document.querySelector(`script[src="${TRUSTPILOT_CONFIG.scriptUrl}"]`);
      
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = TRUSTPILOT_CONFIG.scriptUrl;
        script.async = true;
        script.onload = () => {
          console.log('Trustpilot script loaded');
          initializeWidget();
        };
        script.onerror = () => {
          console.error('Failed to load Trustpilot script');
        };
        document.head.appendChild(script);
      } else {
        // Script already loaded, initialize directly
        initializeWidget();
      }
    };

    const initializeWidget = () => {
      // Poll for Trustpilot to be available
      const pollInterval = setInterval(() => {
        if (window.Trustpilot && widgetRef.current) {
          clearInterval(pollInterval);
          try {
            window.Trustpilot.loadFromElement(widgetRef.current, true);
            setIsLoaded(true);
            console.log('Trustpilot widget initialized');
          } catch (error) {
            console.error('Failed to initialize Trustpilot widget:', error);
          }
        }
      }, 100);

      // Cleanup polling after 10 seconds
      setTimeout(() => {
        clearInterval(pollInterval);
      }, 10000);
    };

    loadScript();
  }, []);

  return (
    <div
      ref={widgetRef}
      className="trustpilot-widget"
      data-locale={TRUSTPILOT_CONFIG.locale}
      data-template-id={TRUSTPILOT_CONFIG.templateId}
      data-businessunit-id={TRUSTPILOT_CONFIG.businessunitId}
      data-style-height="52px"
      data-style-width="100%"
      data-token={TRUSTPILOT_CONFIG.token}
    >
      <a
        href={TRUSTPILOT_CONFIG.reviewUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-godyspo-gold hover:underline"
      >
        View our reviews on Trustpilot
      </a>
    </div>
  );
};
